module.exports = __webpack_public_path__ + "img/ORDER-ABC.b7641c71.png";